import { Action } from '@ngrx/store';

export enum OverviewStackActionTypes {
    Initialize = '[OverviewStack] Initialize',
    Clear = '[OverviewStack] Clear',
    Push = '[OverviewStack] Push',
    Pop = '[OverviewStack] Pop'
}

export class Initialize implements Action {
    readonly type: OverviewStackActionTypes.Initialize = OverviewStackActionTypes.Initialize;

    constructor(public overview: string) {}
}

export class Push implements Action {
    readonly type: OverviewStackActionTypes.Push = OverviewStackActionTypes.Push;

    constructor(public overview: string) {}
}

export class Clear implements Action {
    readonly type: OverviewStackActionTypes.Clear = OverviewStackActionTypes.Clear;
}

export class Pop implements Action {
    readonly type: OverviewStackActionTypes.Pop = OverviewStackActionTypes.Pop;

    constructor(public overview?: string) {}
}

export type OverviewStackActions = Initialize | Clear | Push;
